import type { SxProps, Theme } from '@mui/material/styles';

export const metricTabsRootSx: SxProps<Theme> = {
  width: '100%',
  boxSizing: 'border-box',
  border: 1,
  borderColor: 'divider',
  borderRadius: 1,
  overflow: 'hidden',
};

export const tabsSx: SxProps<Theme> = {
  minHeight: theme => theme.spacing(11),
  backgroundColor: 'background.boxDark',
  borderBottom: 0,
  '& .MuiTabs-list': {
    width: '100%',
    padding: 0,
  },
};

export const tabSx: SxProps<Theme> = {
  alignItems: 'stretch',
  flex: '1 1 0',
  minWidth: theme => theme.spacing(21),
  maxWidth: 'none',
  minHeight: theme => theme.spacing(11),
  padding: 2,
  borderRight: 1,
  borderBottom: 1,
  borderColor: 'divider',
  '&:last-of-type': { borderRight: 0 },
  '&.Mui-selected': {
    backgroundColor: 'background.paper',
    borderBottomColor: 'background.paper',
  },
};

export const panelSx: SxProps<Theme> = {
  backgroundColor: 'background.paper',
  padding: 3,
};

export const labelSx: SxProps<Theme> = {
  alignItems: 'flex-start',
  width: '100%',
};

export const metricRowSx: SxProps<Theme> = {
  alignItems: 'center',
  minHeight: theme => theme.spacing(4),
};

export const metricValueSx: SxProps<Theme> = {
  fontSize: 28,
  fontWeight: theme => theme.typography.h1.fontWeight,
  lineHeight: theme => theme.typography.h1.lineHeight,
  whiteSpace: 'nowrap',
};

export const changeIndicatorSx = (isIncrease: boolean): SxProps<Theme> => ({
  alignItems: 'center',
  color: isIncrease ? 'success.main' : 'error.main',
  whiteSpace: 'nowrap',
});

export const hiddenIndicatorSx: SxProps<Theme> = {
  display: 'none',
};
